import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { AppShell } from "../../../components/app-shell/app-shell";
import { requireMe } from "../../../features/auth/guard";
import { countsQuery, projectsQuery } from "../../../features/workspace/api";

/** Everything inside a workspace: resolves the slug to the caller's membership, then the app shell. */
export const Route = createFileRoute("/w/$slug")({
  beforeLoad: async ({ context, params, location }) => {
    const me = await requireMe(context.queryClient, location.href);
    const workspace = me.memberships.find((membership) => membership.workspaceSlug === params.slug);
    if (!workspace) throw notFound();
    return { me, workspace };
  },
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(projectsQuery(context.workspace.workspaceId));
    void context.queryClient.prefetchQuery(countsQuery(context.workspace.workspaceId));
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
